<template>
    <standard-widget
        widgetTitle="Intervention Tools"
        :cardHeight="cardHeight"
        :cardStyle="$vuetify.breakpoint.md ? 'margin-top: 0 !important' : null"
    >
        <template v-slot:widget-body>
            <div >
                <div
                    v-for="(item, i) in items"
                    class="my-4"
                    :key="`intv-item-${i}`"
                >
                    <div
                        class="d-flex list-text"
                        tabindex="0"
                        role="button"
                        @click="itemClicked(item)"
                        @keydown.enter="itemClicked(item)"
                        @keydown.space.prevent="itemClicked(item)"
                        :data-test="item.dataTest"
                    >
                        <v-icon class="mr-3">{{item.icon}}</v-icon>
                        <div class="text-col">
                            <div>{{item.name}}</div>
                            <div class="text-description"></div>
                        </div>
                        <v-spacer/>
                    </div>
                </div>
            </div>

        </template>
    </standard-widget>
</template>

<script>
    import { mapState } from 'vuex'
    import StandardWidget from './StandardWidget.vue';

    export default {
        name: 'InterventionToolsCard',

        components: {
            StandardWidget
        },

        data() {
            return {
                items: [{
                    key: 'intervention-attendance',
                    name: 'Record Participation/Attendance',
                    windowName: 'Record Intervention Participation',
                    component: 'intervention-participation',
                    icon: 'fas fa-calendar',
                    dataTest: 'record-participation-attendance'
                }, {
                    key: 'probe-scores',
                    name: 'Enter Monitoring Scores',
                    windowName: 'Enter Monitoring Scores',
                    component: 'student-monitor-scores',
                    icon: 'fas fa-edit',
                    dataTest: 'enter-monitoring-scores'
                }, {
                    key: 'point-scores',
                    name: 'Enter Point Scores',
                    windowName: 'Point Sheet Monitoring',
                    component: 'point-sheet-monitoring',
                    icon: 'fas fa-edit',
                    dataTest: 'enter-point-scores'
                }, {
                    key: 'my-interventions',
                    name: 'View My Interventions',
                    windowName: 'Intervention Groups',
                    component: 'intervention-workspace',
                    icon: 'fas fa-list',
                    dataTest: 'view-my-interventions'
                }]
            }
        },

        computed: {
            ...mapState('global', ['sessionUser', 'launchpadWidgetHeights']),

            // In the two-per-row launchpad layout (md), this card shares a row with StudentsCard
            cardHeight() {
                return this.$vuetify.breakpoint.md
                    ? this.launchpadWidgetHeights.secondRow
                    : this.launchpadWidgetHeights.firstRow
            },

            academicParams() {
                return {
                    schedule_date_occurrence: this.$dayjs().format('YYYY-MM-DD'),
                    academic: 1,
                    only_allocated_users: 1
                }
            },

            attrs() {
                return {
                    'intervention-attendance': {},
                    'probe-scores': {
                        params: this.academicParams,
                        class: 'pa-5'
                    },
                    'point-scores': {},
                    'my-interventions': {
                        id: 433
                    }
                }
            },
        },

        methods: {
            itemClicked(item) {
                if (item.route) {
                    this.$router.push(item.route)
                } else if (item.component) {
                    this.$store.commit('global/addDockableWindow', {
                        name: item.windowName,
                        component: item.component,
                        attrs: this.attrs[item.key],
                        events: {
                            interventionDeleted: () => this.$emit(`${item.component}-updated`)
                        }
                    })
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .list-text {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 18px;
        cursor: pointer;

        .text-col {
            .text-description {
                font-size: 80%;
            }
        }

        &:hover {
            text-shadow: 0.5px 0 0 #050F2D;
        }

        &:focus {
            outline: 2px solid #2B87FF;
            outline-offset: 2px;
        }
    }
</style>
